import React, { useRef, useState } from 'react'
import {
  Box,
  ClickAwayListener,
  Grow,
  List,
  ListItemButton
} from '@mui/material'
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { NotificationDataType } from 'src/api'

interface Props {
  notificationType: NotificationDataType | undefined
  onChangeNotificationType: (
    notificationType: NotificationDataType | undefined
  ) => void
  notificationTypeLabels: { [key in NotificationDataType]: string }
}
const NotificationTypeFilterSelect: ReactFC<Props> = ({
  notificationType,
  onChangeNotificationType,
  notificationTypeLabels
}) => {
  const { t } = useTranslation()

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const anchorEl = useRef()

  const handleToggleDropdown = () => {
    setDropdownOpen((open) => !open)
  }

  const handleSelect = (type: NotificationDataType | undefined) => {
    onChangeNotificationType(type)
    setDropdownOpen(false)
  }

  return (
    <ClickAwayListener onClickAway={() => setDropdownOpen(false)}>
      <Box
        sx={{
          display: 'inline',
          position: 'relative'
        }}
        ref={anchorEl}
      >
        <Box
          onClick={handleToggleDropdown}
          sx={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '1rem',
            fontSize: 11,
            color: 'text.secondary',
            cursor: 'pointer'
          }}
        >
          {notificationType
            ? notificationTypeLabels[notificationType]
            : 'Todas'}
          {dropdownOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        </Box>
        {dropdownOpen && (
          <Box
            sx={{
              position: 'absolute',
              left: '0',
              top: '100%',
              zIndex: 999,
              width: '200px'
            }}
          >
            <Grow in={dropdownOpen} translate='yes'>
              <Box>
                <List
                  sx={{
                    backgroundColor: 'background.paper'
                  }}
                >
                  <ListItemButton onClick={() => handleSelect(undefined)}>
                    {t('labels.All')}
                  </ListItemButton>
                  {Object.values(NotificationDataType).map(
                    (notificationType) => (
                      <ListItemButton
                        key={`notificationTypeFilterSelector-${notificationType}`}
                        onClick={() =>
                          handleSelect(notificationType as NotificationDataType)
                        }
                      >
                        {
                          notificationTypeLabels[
                            notificationType as NotificationDataType
                          ]
                        }
                      </ListItemButton>
                    )
                  )}
                </List>
              </Box>
            </Grow>
          </Box>
        )}
        {/* </ClickAwayListener> */}
      </Box>
    </ClickAwayListener>
  )
}
export default NotificationTypeFilterSelect
